export default {"src":"/_next/static/media/logo.843a751b.svg","height":90,"width":436};